export default __webpack_public_path__ + "static/media/Visa-Emblema.1eff9dff.png";